import { render, staticRenderFns } from "./suspect_matches.vue?vue&type=template&id=55bdd3af&scoped=true"
import script from "./suspect_matches.vue?vue&type=script&lang=js"
export * from "./suspect_matches.vue?vue&type=script&lang=js"
import style0 from "./suspect_matches.vue?vue&type=style&index=0&id=55bdd3af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bdd3af",
  null
  
)

export default component.exports